import { createApp } from 'vue'
import Notifications from '@kyvg/vue3-notification';
// import vuelidate from 'vuelidate';

import App from './App.vue';
import router from './router/index';
import store from './store/index';
import loader from './components/Loader.vue';


import './permission';


const app = createApp(App);
app.config.globalProperties.$filters = {
  dateformat(value)
  {
    if (!value) return '';
  
    // const curDate = new Date(value);
    const newVal = `${new Date(value).toLocaleDateString('en-IN', {
      year: 'numeric', month: 'short', day: 'numeric', timeZone: 'Asia/Kolkata',
    })
    } ${new Date(value).toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata' })}`;
    return newVal;
  },
  dateformat1(value)
  {
    if (!value) return '';
  const newVal = `${new Date(value).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })}`;
  if(newVal=="Invalid Date"){
    return "N/A"
}
  return newVal;
  },
  priceformat(amount)
  {
    if (!amount) {
      return '';
    }
    
    if (amount == 0) { return '₹0.00'; }
    return amount.toLocaleString('en-IN', {
      maximumFractionDigits: 2,
      style: 'currency',
      currency: 'INR',
    });
  },
  numberFormat(value)
  {
    if (!value) return '';
    return value.toLocaleString('en-IN');
  }
}
app.directive("disable-leading-space",{
  update(el) {
              // using regex to only remove spaces at the beginning
              el.value = el.value.replace(/^\s+/g, ''); // or you can use your own preferred way to remove leading spaces
              el.dispatchEvent(new Event('input'));
          },
})

app.config.productionTip = false;
// Vue.use(Notifications);
// Vue.use(vuelidate);
app.component('loader', loader);
// Vue.filter('dateformat', (value) => {
//   if (!value) return '';
  
//   // const curDate = new Date(value);
//   const newVal = `${new Date(value).toLocaleDateString('en-IN', {
//     year: 'numeric', month: 'short', day: 'numeric', timeZone: 'Asia/Kolkata',
//   })
//   } ${new Date(value).toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata' })}`;
//   return newVal;
// });
// Vue.filter('dateformat1', (value) => {
//   if (!value) return '';
//   const newVal = `${new Date(value).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })}`;
//   if(newVal=="Invalid Date"){
//     return "N/A"
// }
//   return newVal;
// });

// Vue.filter('priceformat', (amount) => {
  
//   //amount = Number(amount);
//   if (!amount) {
//     return '';
//   }
  
//   if (amount == 0) { return '₹0.00'; }
//   return amount.toLocaleString('en-IN', {
//     maximumFractionDigits: 2,
//     style: 'currency',
//     currency: 'INR',
//   });

// });
// Vue.filter('numberFormat', (value) => {
//   if (!value) return '';
//   return value.toLocaleString('en-IN');
// });
// Vue.directive('disable-leading-space', { // you can rename it to your liking
//   update(el) {
//     // using regex to only remove spaces at the beginning
//     el.value = el.value.replace(/^\s+/g, ''); // or you can use your own preferred way to remove leading spaces
//     el.dispatchEvent(new Event('input'));
//   },
// });
app.use(store);
app.use(router);
app.use(Notifications);
app.mount('#app');
